import { ReactElement, useCallback } from 'react';

import { TranslatableText, useBoolean } from '@dreryk/react-common';

import { NfzMfaModal } from './NfzMfaModal';
import { NfzMfaTotpErrorSetter } from './NfzMfaForm.types';

type NfzMfaModalOpenerProps = {
   onLogin: (mfaTotp: string, setError: NfzMfaTotpErrorSetter) => Promise<void>;
   onCancel?: VoidFunction;
   blockingOperationLabel?: TranslatableText;
};

type UseNfzMfaModalOpenerReturn = {
   openNfzMfaModal: VoidFunction;
   closeNfzMfaModal: VoidFunction;
   nfzMfaModalOpened: boolean;
   renderNfzMfaModal: (props: NfzMfaModalOpenerProps) => ReactElement | null;
};

export const useNfzMfaModalOpener = (): UseNfzMfaModalOpenerReturn => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();

   return {
      openNfzMfaModal: openModal,
      closeNfzMfaModal: closeModal,
      nfzMfaModalOpened: modalOpened,
      renderNfzMfaModal: useCallback(
         (props) => {
            if (modalOpened) {
               const handleClose = (): void => {
                  closeModal();
                  props.onCancel?.();
               };

               return (
                  <NfzMfaModal
                     onClose={handleClose}
                     onLogin={props.onLogin}
                     blockingOperationLabel={props.blockingOperationLabel}
                  />
               );
            }

            return null;
         },
         [closeModal, modalOpened]
      ),
   };
};
